module.exports = __webpack_public_path__ + "media/images/icons/sw-care-7f54b79c2733bd84653afc498aa13cb8.svg";